module.exports = __webpack_public_path__ + "img/facebook.3fd67795.svg";